import React from "react";
import Button from "../Common/Buttons";
import { Flex } from "../Common/Flex";
import Label from "../Common/Label";
import "./ItemNotFound.css";

type ItemNotFoundProps = {
    contentItemId: string;
    onClose: () => void;
};

function ItemNotFound(props: ItemNotFoundProps) {
    const { contentItemId, onClose } = props;
    return (
        <Flex.Column
            gap="large"
            className="item-not-found"
            alignItems="center"
            justifyContent="center"
        >
            <h3>This content doesn&apos;t seem to exist anymore</h3>

            <Flex.Column gap="xlarge" alignItems="center">
                <Flex.Column gap="medium" alignItems="center">
                    <Label.Medium.Light.N50>
                        If you think this is a mistake, let the tech team find the
                        content with following id:
                    </Label.Medium.Light.N50>

                    <Label.Medium.Light>{contentItemId}</Label.Medium.Light>
                </Flex.Column>

                <Button.N10
                    onClick={() => {
                        onClose();
                    }}
                >
                    Go back
                </Button.N10>
            </Flex.Column>
        </Flex.Column>
    );
}

export default ItemNotFound;
